module.exports = __webpack_public_path__ + "static/media/premiacao_01.b310426f.jpg";